<template>
  <div>
    <div v-if="value.salaryStatements">
      <div v-for="(salaryStatement, i) in value.salaryStatements" :key="i" class="salary-statement-fields">
        <div v-for="(glossValues, gloss) in salaryStatement" :key="gloss.name" class="salary-statement-field">
          <div class="inputs-title">
            <div class="inputs-title-text">
              <span class="title-text is-size-6 has-text-weight-semibold">{{ salaryStatementGlosses[gloss].title }}</span>
              <span class="title-comment is-size-7">{{ salaryStatementGlosses[gloss].comment }}</span>
            </div>
            <a
              :id="`${debtorIndex}-add-${salaryStatementGlosses[gloss].id}`"
              href="#"
              class="fa fa-plus-circle"
              @click="$emit('add-input', { debtorIndex, type: 'income', gloss})" />
          </div>
          <div v-for="(glossValue, j) in glossValues" :key="`${i}-${gloss}-${j}`" class="gloss-value">
            <a
              :id="`debt-${i}-${gloss}-${j}-delete-button`"
              href="#"
              @click.prevent="$emit(
                'delete-input',
                { debtorIndex, type: 'income', incomeType: 'salaryStatements', incomeIndex: i, gloss, inputIndex: j }
              )">
              <i class="fa-solid fa-trash-can" />
            </a>
            <div class="b-field-inputs">
              <div
                v-for="(field, fieldName) in salaryStatementGlosses[gloss].glossFields"
                :key="`${i}-${gloss}-${j}-${fieldName}`"
                class="b-field-input">
                <div v-if="field.jsonType==='array'" class="b-field-inputs">
                  <BaseInput
                    v-for="k in field.quantity"
                    :id="`${debtorIndex}-${i}-${gloss}-${j}-${fieldName}-${k}`"
                    :key="k"
                    class="b-field-input"
                    :value="value.salaryStatements[i][gloss][j][fieldName][k-1]"
                    :type="field.type"
                    :format-type="field.formatType"
                    :title="`${field.title} ${k}`"
                    :placeholder="field.placeholder"
                    :icon="field.icon"
                    @input="value => updateInputs(value, i, gloss, j, fieldName, k-1)" />
                </div>
                <div v-else>
                  <BaseInput
                    :id="`${debtorIndex}-${i}-${gloss}-${j}-${fieldName}`"
                    :value="value.salaryStatements[i][gloss][j][fieldName]"
                    :type="field.type"
                    :format-type="field.formatType"
                    :title="field.title"
                    :placeholder="field.placeholder"
                    :icon="field.icon"
                    @input="newValue => updateInputs(newValue, i, gloss, j, fieldName, null)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="inputs.otherIncomes">
        OTROS INGRESOS
      </div> -->
  </div>
</template>

<script>
import BaseInput from '@/ui/components/internal/risk-evaluation/BaseInput.vue';

export default {
  name: 'IncomeInputs',
  components: { BaseInput },
  props: {
    value: { type: Object },
    debtorIndex: Number
  },
  data() {
    const descriptionField = {
      title: 'Descripción',
      type: 'text',
      formatType: 'text',
      placeholder: ''
    };
    const amountField = (title, jsonType = 'number', formatType = 'number', quantity = 1) => ({
      title,
      jsonType,
      type: 'number',
      formatType,
      placeholder: 'Monto',
      icon: 'a-solid fa-dollar-sign',
      quantity
    });
    const periodicityField = {
      title: 'Periodicidad',
      type: 'number',
      formatType: 'currencyNumber',
      icon: 'fa-regular fa-calendar',
      placeholder: 'Meses'
    };
    return {
      inputs: {},
      salaryStatementGlosses: {
        fixedIncomes: {
          glossFields: {
            description: descriptionField,
            amounts: amountField('Mensualidad', 'number', 'currencyNumber')
          },
          id: 'taxable-fixed-income',
          title: 'Haberes fijos imponibles',
          comment: 'ej: Sueldo Base, Gratificación, Asignación'
        },
        variableNonPeriodicIncomes: {
          glossFields: {
            description: descriptionField,
            amounts: amountField('Mes', 'array', 'currencyNumber', 3)
          },
          id: 'taxable-nonperiodic-income',
          title: 'Haberes variables imponibles',
          comment: 'ej: HHEE'
        },
        variablePeriodicIncomes: {
          glossFields: {
            description: descriptionField,
            periodicity: periodicityField,
            amounts: amountField('Monto', 'number', 'currencyNumber')
          },
          id: 'taxable-periodic-income',
          title: 'Haberes variables imponibles (periódicos)',
          comment: 'ej: Bono'
        },
        nonTaxableIncomes: {
          glossFields: {
            description: descriptionField,
            amounts: amountField('Mes', 'array', 'currencyNumber', 3)
          },
          id: 'nontaxable-fixed-income',
          title: 'Haberes fijos no imponibles',
          comment: 'ej: Colación, movilización...'
        },
        otherDiscounts: {
          glossFields: {
            description: descriptionField,
            amounts: amountField('Mensualidad', 'number', 'currencyNumber')
          },
          id: 'other-discount',
          title: 'Otros descuentos',
          comment: 'ej: Retenciones judiciales, Seguros adicionales...'
        }
      }
      // otherIncomesGlosses: [
      //   {
      //     gloss: 'income',
      //     glossFields: {
      //       description: descriptionField,
      //       amounts: amountField('Mensualidad', 'number', 'currencyNumber')
      //     },
      //     id: 'other-income',
      //     title: 'Otros ingresos',
      //     comment: 'ej: Pensiones, arriendos...'
      //   }
      // ]
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(vModelValues) {
        this.inputs = vModelValues;
      }
    }
  },
  methods: {
    updateInputs(value, statementIndex, gloss, glossIndex, fieldName, amountIndex = null) {
      const updated = JSON.parse(JSON.stringify(this.inputs));
      if (amountIndex === null) {
        updated.salaryStatements[statementIndex][gloss][glossIndex][fieldName] = value;
      } else {
        updated.salaryStatements[statementIndex][gloss][glossIndex][fieldName][amountIndex] = value;
      }
      this.$emit('input', updated);
    }
  }
};
</script>

<style scoped>
.gloss-value {
  display: flex;
  align-items: center;
  gap: 1rem 1rem;
}
.salary-statement-fields {
  display: flex;
  flex-flow: column wrap;
  gap: 1rem;
}
.salary-statement-field {
  display: flex;
  flex-flow: column wrap;
  gap: 2rem;
}
.inputs-title-text {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 0rem 1rem;
}
.inputs-title {
  display: grid;
  grid-template-columns: 1fr 1rem;
  align-items: center;
}
.b-field-inputs {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 1rem 1rem;
}
.b-field-input {
  flex-grow: 1;
}
</style>
